module.exports = __webpack_public_path__ + "media/customer.b404ecc6.mp3";